import {css} from '@emotion/react'
import {MarkdownEditor, MarkdownViewer} from '@/components/Markdown'
import {MapContext} from '@/components/MindMap'
import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import runAsync from '@/script/runAsync.mjs'
import useBizNode from '../../useBizNode.mjs'
import ToolBar from './ToolBar.jsx'
import useMap from './useMap.mjs'

const cssMarkdownMap = css({
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    backgroundColor: '#fff',
    overflow: 'hidden',
})

const MarkdownMap = ({data, permission, ...props}) => {
    const map = useMap({data, permission})

    return (
        <div
            css={cssMarkdownMap}
            {...props}
        >
            <MapContext.Provider value={map}>
                <ToolBar />

                {
                    map.permission.has('write') ?
                        <MarkdownEditor
                            value={map.content}
                            onChange={value => map.setContent(value)}
                        />
                        :
                        <MarkdownViewer className="p-2">
                            {map.content}
                        </MarkdownViewer>
                }
            </MapContext.Provider>
        </div>
    )
}

export default function MarkdownMapWrapper({id, permission, type, ...props}) {
    const BizNode = useBizNode()

    const {data} = useSwrNoCache(
        () => runAsync(
            async () => {
                const {
                    dpContent: content,
                    ...dp
                } = await BizNode[type].api.read({pkid: id})

                dp.bizNodeType = type
                return {dp, content}
            },

            {action: '读取地图'}
        )
    )

    if (! data) {
        return null
    }

    return (
        <MarkdownMap
            data={data}
            permission={permission}
            {...props}
        />
    )
 }
